// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_dr-HK","control-wrap":"control-wrap_3BfLl","g-control":"g-control"};